import React, { Component } from 'react';
import InputMask from 'react-input-mask';
import HttpUtil from '../../Util/httpUtil';
import Config from '../../Util/config';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Container, Row, Col } from 'reactstrap';
import '../../_Content/css/ajuda.css';

class Ajuda extends Component {
	constructor(props) {
		super(props);

		this.state = {
			modal: 1,
			backdrop: true,
			validarNome: '',
			validarEmail: '',
			validarContato: '',
			foneFormatado: '(99) 999999999',
			nomeCliente: '',
			emailCliente: '',
			mensagem: '',
			contatoCliente: '',
			validarFormulario: false,
			modalVisivel: false,
			exibirRetorno: false,
			mensagemRetorno: '',
			classeMensagemRetorno: 'valid-feedback text-center',
			ambienteHomol: window.location.href.indexOf("ec2-34-206-89-100.compute-1.amazonaws.com:9090") > 0 ? true : false,
			idCliente: localStorage.getItem("CodUsuario")
		};
	}

	validateFormBeforeSubmit = () => {
		let isEnabled = this.state.validarNome === 'valido' && this.state.validarEmail === 'valido' && this.state.validarContato === 'valido';

		this.setState({
			validarFormulario: isEnabled,
		});
	};

	toggleModal = () => {
		this.setState({
			modal: 2,
		});
	};

	modalAjudaHomol = (data) => {
		this.setState({
			modalVisivel: !this.state.modalVisivel,
			modal: 2,
			exibirRetorno: false,
			mensagemRetorno: '',
			classeMensagemRetorno: 'valid-feedback text-center'
		});
	};

	alterarVisibilidadeModal = (data) => {
		this.setState({
			modalVisivel: !this.state.modalVisivel,
			modal: 1,
			exibirRetorno: false,
			mensagemRetorno: '',
			classeMensagemRetorno: 'valid-feedback text-center',
			status: data.status
		});
	};

	onHandlerNome = event => {
		if (event.target.value !== '') {
			this.setState({
				nomeCliente: event.target.value,
			});

			this.state.validarNome = 'valido';
			this.validateFormBeforeSubmit();
		} else {
			this.state.validarNome = 'invalido';
			this.validateFormBeforeSubmit();
		}
	};

	formatInputPhoneMask = event => {
		let valor = event.target.value.trim();
		let qntChar = valor.length;

		if (qntChar == 13) {
			this.setState({
				foneFormatado: '(99) 9999-99999',
				contatoCliente: event.target.value,
			});

			this.state.validarContato = 'valido';
			this.validateFormBeforeSubmit();
		} else if (qntChar == 14) {
			this.setState({
				foneFormatado: '(99) 99999-9999',
				contatoCliente: event.target.value,
			});

			this.state.validarContato = 'valido';
			this.validateFormBeforeSubmit();
		} else if (qntChar < 13 || qntChar === 0) {
			this.setState({
				foneFormatado: '(99) 999999999',
				contatoCliente: '',
			});

			this.state.validarContato = 'invalido';
			this.validateFormBeforeSubmit();
		}
	};

	validateEmail = event => {
		let regex = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

		if (regex.test(event.target.value)) {
			this.setState({
				emailCliente: event.target.value,
			});

			this.state.validarEmail = 'valido';
			this.validateFormBeforeSubmit();
		} else {
			this.state.validarEmail = 'invalido';
			this.state.emailCliente = '';

			this.validateFormBeforeSubmit();
		}
	};

	sendFeedbackData = () => {
		return new Promise((resolve, reject) => {
			let data = new FormData();
			data.append('NOME', this.state.nomeCliente);
			data.append('EMAIL', this.state.emailCliente);
			data.append('TELEFONE', this.state.contatoCliente);
			data.append('AMBIENTEHOMOL', this.state.ambienteHomol);
			data.append('IDCLIENTE', this.state.idCliente);
			data.append('MENSAGEM', this.state.mensagem);

			HttpUtil.eco_POST(
				`${Config.urls.API_URL_BASE}FeedbackErros/EnviarEmail`,
				data,
				response => {
					resolve({ resposta: response.data });
				},
				() => {
					this.setState({
						exibirRetorno: true,
						mensagemRetorno: 'Não foi possível enviar a mensagem.',
					});
					console.log('erro');
				},
			);
		});
	};

	preparaParaEnviarFeedback = () => {
		this.sendFeedbackData().then(retorno => {
			this.setState({ exibirRetorno: true });
			if (retorno.resposta) {
				this.setState({
					mensagemRetorno: 'Mensagem enviada com sucesso!',
					classeMensagemRetorno: 'valid-feedback text-center',
				});
			} else {
				this.setState({
					mensagemRetorno: 'Não foi possível enviar a mensagem.',
					classeMensagemRetorno: 'invalid-feedback text-center',
				});
			}
		});
	};

	handleChange = event => {
		this.setState({ nome: event.target.value });
	};

	handleMsg = event => {
		this.setState({ mensagem: event.target.value })
	}

	goBack = props => {
		this.props.history.goBack();
	};

	mensagemModal = (status) => {

		if (status == "ErroSimplesNacional") {
			return (
				<div className="modalTxt">
					<p>O arquivo informado não foi considerado Simples Nacional pela combinação de estado e perfil.</p>
					<p>Os estados disponíveis são: Alagoas (Perfil A), Ceará (Perfil B), Mato Grosso do Sul (Perfil A e C), Paraíba (perfil A) e Rio Grande do Norte (perfil C).</p>
				</div>
			)
		}
		else {
			return (
				<div>
					<div className="modalTxt">
						<p>
							Não foi possível finalizar a validação do arquivo.<br />
							Aguarde e tente novamente, ou solicite ajuda.
						</p>
					</div>
					<Row>
						<Col>
							<div className="btsBox">
								<Button className="float-left ecobtn vazado fat baby-blue" onClick={this.alterarVisibilidadeModal.bind(this)}>
									Ok, fechar
							</Button>{' '}
								<Button className="float-right ecobtn vazado fat verde" onClick={this.toggleModal.bind(this)}>
									Ajuda
							</Button>
							</div>
						</Col>
					</Row>
				</div>
			)
		}
	}

	openModal = () => {
		if (this.state.modal == '1') {
			return (
				<Modal id="modal-ajuda" isOpen={this.state.modalVisivel} toggle={this.state.toggle} className={this.props.className}>
					<ModalHeader toggle={this.state.toggle} onClick={this.alterarVisibilidadeModal.bind(this)}>
						<i className="fas fa-times"></i>
					</ModalHeader>
					<ModalBody>
						<Container>
							<Row>
								<Col>
									<img src="/img/ecoicos/ecoico-erro.svg" alt="erro" />
									<label>Desculpe, ocorreu um erro!</label>
									{this.mensagemModal(this.state.status)}
								</Col>
							</Row>
						</Container>
					</ModalBody>
				</Modal>
			);
		}

		if (this.state.modal == '2') {
			return (
				<Modal id="modal-ajuda2" isOpen={this.state.modalVisivel} toggle={this.state.toggle} className={this.props.className}>
					<ModalBody>
						<Container>
							<Row>
								<Col>
									<label className="lblTitulo">Deixe os seus dados e entraremos em contato</label>
									<br />

									<div>
										<div>
											<input
												type="text"
												className={this.state.validarNome === 'invalido' ? 'form-control invalid' : 'form-control'}
												onBlur={this.onHandlerNome}
												placeholder="Nome"
												value={this.state.nome}
											/>
										</div>
										<div>
											<input
												type="text"
												className={this.state.validarEmail === 'invalido' ? 'form-control invalid' : 'form-control'}
												onBlur={this.validateEmail}
												placeholder="E-mail"
											/>
										</div>
										<div>
											<InputMask
												className={this.state.validarContato === 'invalido' ? 'form-control invalid' : 'form-control'}
												{...this.props}
												mask={this.state.foneFormatado}
												maskChar=" "
												onBlur={this.formatInputPhoneMask}
												placeholder="Telefone"
											/>
										</div>
										{this.state.ambienteHomol ?
										(<div>
											<textarea name="msg" placeholder="Mensagem" onKeyUp={this.handleMsg}></textarea>
										</div>) : ("")
										}

										{this.state.exibirRetorno && (
											<div>
												<span className={this.state.classeMensagemRetorno} style={{ display: 'block' }}>
													{this.state.mensagemRetorno}
												</span>
											</div>
										)}
									</div>
								</Col>
							</Row>
							<Row>
								<Col>
									<div className="btsBox">
										<Button className="float-left ecobtn vazado fat vermelho" onClick={this.alterarVisibilidadeModal.bind(this)}>
											Fechar
									</Button>
										<Button className={!this.state.validarFormulario ? "float-right ecobtn vazado fat cinza" : "float-right ecobtn vazado fat verde"} onClick={this.preparaParaEnviarFeedback} disabled={!this.state.validarFormulario}>
											Enviar
									</Button>
									</div>
								</Col>
							</Row>
						</Container>
					</ModalBody>
				</Modal>
			);
		}
	};

	render() {
		return <div>{this.openModal()}</div>;
	}
}

export default Ajuda;



// WEBPACK FOOTER //
// ./src/Componente/Ajuda/Ajuda.jsx